import {CreativeTemplate} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {setAiCreativeTemplatesFilter} from 'common/src/modules/creativeTemplates/store/creativeTemplatesLibrary/creativeTemplatesLibrary.slice';
import {Tool} from 'common/src/modules/shared/copilot/copilot.types';
import filterTableTool from 'common/src/modules/shared/copilot/tools/filterTableTool/filterTableTool';
import {CLStore} from 'common/src/redux/store';
import {ZodTypeAny} from 'zod';
import {creativeTemplatesSchema} from '../creativeTemplatesManagerAgent.consts';

function filterCreativeTemplatesLibraryTool(store: CLStore): Tool<ZodTypeAny> {
  const tool = filterTableTool({
    displayName: 'Filtering creative templates',
    dataTypeSchema: creativeTemplatesSchema,
    fetchData: () => {
      return store.getState().creativeTemplatesLibrary.templates;
    },
    filterFunction: (data: CreativeTemplate[], query: string) =>
      store.dispatch(
        setAiCreativeTemplatesFilter({
          aiFilteredIds: data.map((template) => template.id),
          query,
        }),
      ),
    clearFilter: () => store.dispatch(setAiCreativeTemplatesFilter({aiFilteredIds: [], query: ''})),
  });

  tool.description = 'Filter creative templates in the creative templates library and clear filter';

  return tool;
}

export default filterCreativeTemplatesLibraryTool;
